import {ACTION_TYPES, COMPONENT_STATES} from "../../../core/consts";
import {PropositionBetsWidgetController} from "../proposition-bets-widget.controller";
import {DeltaHandler} from "../../../infrastructure/handlers/delta-handler";
import type {PropositionBetsWidgetState} from "../models/proposition-bets-widget.state";
import type {PropositionBetsDataSource} from "../../../domain/bets/proposition/models/proposition-bets.data-source";
import {PropositionBetsRequestParams} from "../../../domain/bets/proposition/models/proposition-bets.request-params";
import {PropositionBetsDomainService} from "../../../domain/bets/proposition/services/proposition-bets.domain-service";
import {PROPOSITION_BETS} from "../proposition-bets-widgets.consts";

export class PropositionBetsWidgetFetchHandler extends DeltaHandler {
  controller: PropositionBetsWidgetController;
  state: PropositionBetsWidgetState;

  static injectables = [PropositionBetsDomainService];

  onLoaded() {
    super.onLoaded();
    this.store.setComponentState(COMPONENT_STATES.loading);

    this.action();
  }

  get requestParams(): PropositionBetsRequestParams {
    const gameId: Number = this.controller.props.gameId;
    const topBookmakerId = this.state.appState.topBookmakerId;
    const isPreview: Number = this.controller.props.isPreview;

    const requestParams: PropositionBetsRequestParams = new PropositionBetsRequestParams(gameId, null, topBookmakerId, !isPreview);

    return requestParams;
  }

  async action() {
    const dataSource: PropositionBetsDataSource = await super.fetch();
    this.controller.action(ACTION_TYPES.populateData, {dataSource});
    this.controller.props.onWidgetVisible?.(this.state.isPopulated);
    return dataSource;
  }


  async onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const isCompetitionChanged: Boolean = nextProps.competitionId !== prevProps.competitionId;

    if (isCompetitionChanged) {
      await this.action();
    }
  }

  populateDelta(response, params) {
    this.controller.action(ACTION_TYPES.populateData, {dataSource: response});
  }

  onUnloaded() {
    super.onUnloaded();

    this.controller.action(PROPOSITION_BETS.ACTION_TYPES.onPopupClick);
  }
}
